import { Children } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from '../../App';
import AiboatVideoSection from '../../components/AiboatVideoSection';

export const router = createBrowserRouter([
    // {
    //     path: '/ai/playground',
    //     element: <App />,
    //     children: [
    //         {
    //             path: '/ai/playground/:id',
    //             element: <App />
    //         }
    //     ]
    // },
    {
        // path: '/ai/aionboarding',
        path: '/playground',
        element: <AiboatVideoSection />,
        children: [
            {
                path: '/playground/:id',
                element: <AiboatVideoSection />
            },
            {
                path: '/playground/:affiliateid/:id',
                element: <AiboatVideoSection />
            },
        ]
    }
]);